import type { ReactNode } from "react"

const iconClass = "w-5 h-5"

type BrandIconProps = {
  viewBox: string
  color: string
  children: ReactNode
}

const BrandIcon = ({ viewBox, color, children }: BrandIconProps) => (
  <svg viewBox={viewBox} className={iconClass} fill={color} aria-hidden>
    {children}
  </svg>
)

const VkIcon = () => (
  <BrandIcon viewBox="0 0 24 24" color="#0077FF">
    <path d="m9.489.004.729-.003h3.564l.73.003.914.01.433.007.418.011.403.014.388.016.374.021.36.025.345.03.333.033c1.74.196 2.933.616 3.833 1.516.9.9 1.32 2.092 1.516 3.833l.034.333.029.346.025.36.02.373.025.588.012.41.013.644.009.915.004.98-.001 3.313-.003.73-.01.914-.007.433-.011.418-.014.403-.016.388-.021.374-.025.36-.03.345-.033.333c-.196 1.74-.616 2.933-1.516 3.833-.9.9-2.092 1.32-3.833 1.516l-.333.034-.346.029-.36.025-.373.02-.588.025-.41.012-.644.013-.915.009-.98.004-3.313-.001-.73-.003-.914-.01-.433-.007-.418-.011-.403-.014-.388-.016-.374-.021-.36-.025-.345-.03-.333-.033c-1.74-.196-2.933-.616-3.833-1.516-.9-.9-1.32-2.092-1.516-3.833l-.034-.333-.029-.346-.025-.36-.02-.373-.025-.588-.012-.41-.013-.644-.009-.915-.004-.98.001-3.313.003-.73.01-.914.007-.433.011-.418.014-.403.016-.388.021-.374.025-.36.03-.345.033-.333c.196-1.74.616-2.933 1.516-3.833.9-.9 2.092-1.32 3.833-1.516l.333-.034.346-.029.36-.025.373-.02.588-.025.41-.012.644-.013.915-.009ZM6.79 7.3H4.05c.13 6.24 3.25 9.99 8.72 9.99h.31v-3.57c2.01.2 3.53 1.67 4.14 3.57h2.84c-.78-2.84-2.83-4.41-4.11-5.01 1.28-.74 3.08-2.54 3.51-4.98h-2.58c-.56 1.98-2.22 3.78-3.8 3.95V7.3H10.5v6.92c-1.6-.4-3.62-2.34-3.71-6.92Z" />
  </BrandIcon>
)

const TelegramIcon = () => (
  <BrandIcon viewBox="0 0 24 24" color="#26A5E4">
    <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" />
  </BrandIcon>
)

const OkIcon = () => (
  <BrandIcon viewBox="0 0 24 24" color="#EE8208">
    <path d="M12 0a6.2 6.2 0 0 0-6.194 6.195 6.2 6.2 0 0 0 6.195 6.192 6.2 6.2 0 0 0 6.193-6.192A6.2 6.2 0 0 0 12.001 0zm0 3.63a2.567 2.567 0 0 1 2.565 2.565 2.568 2.568 0 0 1-2.564 2.564 2.568 2.568 0 0 1-2.565-2.564 2.567 2.567 0 0 1 2.565-2.564zM6.807 12.6a1.814 1.814 0 0 0-.91 3.35 11.611 11.611 0 0 0 3.597 1.49l-3.462 3.463a1.815 1.815 0 0 0 2.567 2.566L12 20.066l3.405 3.403a1.813 1.813 0 0 0 2.564 0c.71-.709.71-1.858 0-2.566l-3.462-3.462a11.593 11.593 0 0 0 3.596-1.49 1.814 1.814 0 1 0-1.932-3.073 7.867 7.867 0 0 1-8.34 0c-.318-.2-.674-.29-1.024-.278z" />
  </BrandIcon>
)

const MaxIcon = () => (
  <BrandIcon viewBox="0 0 42 42" color="#007AFF">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.47 41.88c-4.11 0-6.02-.6-9.34-3-2.1 2.7-8.75 4.81-9.04 1.2 0-2.71-.6-5-1.28-7.5C1 29.5.08 26.07.08 21.1.08 9.23 9.82.3 21.36.3c11.55 0 20.6 9.37 20.6 20.91a20.6 20.6 0 0 1-20.49 20.67m.17-31.32c-5.62-.29-10 3.6-10.97 9.7-.8 5.05.62 11.2 1.83 11.52.58.14 2.04-1.04 2.95-1.95a10.4 10.4 0 0 0 5.08 1.81 10.7 10.7 0 0 0 11.19-9.97 10.7 10.7 0 0 0-10.08-11.1Z"
    />
  </BrandIcon>
)

const DzenIcon = () => (
  <BrandIcon viewBox="0 0 48 48" color="#FC3F1D">
    <path d="M24.72,0c.12,9.73.79,15.2,4.44,18.84,3.65,3.65,9.12,4.31,18.85,4.44C47.63,10.59,37.41.37,24.72,0Z" />
    <path d="M18.85,18.84C22.5,15.2,23.16,9.73,23.28,0,10.59.37.37,10.59,0,23.28c9.73-.12,15.2-.79,18.85-4.44Z" />
    <path d="M0,24.72c.37,12.69,10.59,22.91,23.28,23.28-.12-9.73-.79-15.2-4.44-18.84-3.65-3.65-9.12-4.31-18.85-4.44Z" />
    <path d="M48,24.72c-9.73.12-15.2.79-18.85,4.44-3.65,3.65-4.31,9.12-4.44,18.84,12.69-.37,22.91-10.59,23.28-23.28Z" />
  </BrandIcon>
)

const LiveJournalIcon = () => (
  <BrandIcon viewBox="0 0 24 24" color="#00B0EA">
    <path d="M18.09 14.696c-1.512.664-2.726 1.885-3.381 3.399l4.27.883-.886-4.282h-.003zM2.475 8.317L0 5.85C1.125 3.237 3.216 1.14 5.823 0h.006l2.469 2.463c1.368-.591 2.876-.921 4.463-.921C18.967 1.542 24 6.569 24 12.771 24 18.973 18.967 24 12.761 24 6.551 24 1.52 18.976 1.52 12.771c0-1.591.355-3.081.952-4.451l9.143 9.114c1.125-2.613 3.218-4.71 5.823-5.85l-9.135-9.12h-.008c-2.606 1.14-4.695 3.24-5.823 5.85l.003.003z" />
  </BrandIcon>
)

export type FooterSocialLink = {
  href: string
  labelKey: string
  icon: ReactNode
}

export const footerSocialLinks: FooterSocialLink[] = [
  {
    href: "http://vk.com/leninka_ru",
    labelKey: "footer.socialVk",
    icon: <VkIcon />,
  },
  {
    href: "https://t.me/leninka_ru",
    labelKey: "footer.socialTelegram",
    icon: <TelegramIcon />,
  },
  {
    href: "https://ok.ru/leninka",
    labelKey: "footer.socialOk",
    icon: <OkIcon />,
  },
  {
    href: "https://max.ru/leninka_ru",
    labelKey: "footer.socialMax",
    icon: <MaxIcon />,
  },
  {
    href: "https://zen.yandex.ru/leninka",
    labelKey: "footer.socialZen",
    icon: <DzenIcon />,
  },
  {
    href: "https://leninka-ru.livejournal.com/",
    labelKey: "footer.socialLiveJournal",
    icon: <LiveJournalIcon />,
  },
]

export const footerSocialLinkClassName =
  "w-10 h-10 rounded-full border border-lib-border flex items-center justify-center bg-white hover:bg-lib-bg/60 hover:border-lib-accent/30 transition-colors"
